import { Howl } from 'howler';

function fetchAudio(audioUrl) {
  const audio = document.createElement('audio');

  return new Promise((resolve, reject) => {
    audio.onloadeddata = function() {
      resolve(audio);
    };

    audio.onerror = function(err) {
      reject(err);
    };

    audio.src = audioUrl;
  });
}

const createAudioAsync = (src, { html5 = false, ...config } = {}) =>
  new Promise((resolve) => {
    const howl = new Howl({
      src,
      html5,
      ...config,
      onload: () => resolve(howl),
      onloaderror: () => {
        resolve({
          play: () => {},
          stop: () => {}
        });
      }
    });
  });

export { fetchAudio, createAudioAsync };
